import { useEffect, useState } from 'react'

type Countdown = {
  hours: string
  minutes: string
  seconds: string
}

const START_SECONDS = 23 * 3600 + 46 * 60 + 3

export function useCountdown(): Countdown {
  const [remaining, setRemaining] = useState(START_SECONDS)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 0 ? START_SECONDS : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  const pad = (value: number) => String(value).padStart(2, '0')

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  }
}
